import { useStateWrapper } from '../../hooks'
import { GET_API_VERSION } from '../../graphql'
import { VersionInfoQueryType } from '../../types'
import { LabeledText, PageLayout } from '../../components'

export const VersionInfo = () => {
  const { StateRenderWrapper, data } = useStateWrapper<VersionInfoQueryType>({
    query: GET_API_VERSION
  })

  return (
    <PageLayout>
      <LabeledText
        label="Front version"
        defaultText={
          process.env.REACT_APP_CI_COMMIT_TAG?.toString() || 'not set'
        }
      />
      <StateRenderWrapper>
        <LabeledText
          label="API version"
          defaultText={data?.versionInfo.version}
        />
      </StateRenderWrapper>
    </PageLayout>
  )
}
